module.exports = __webpack_public_path__ + "static/img/yingxiao_icon4.f0cc6ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/broadcast/yingxiao_icon4.png
// module id = B427
// module chunks = 0